import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import PopoverListItem from '@gik/ui/PopoverListItem';
import { navigateTo } from '@/utils/environment';

const blockName = 'menu-item';

interface MenuItemBase {
  label: string | React.ReactElement;
  icon?: string;
}

export interface MenuItemHref extends MenuItemBase {
  href: string;
}

export interface MenuItemClickable extends MenuItemBase {
  onClick: () => void;
}

export type IMenuItem = MenuItemClickable | MenuItemHref;

export interface IMenuItemProps {
  item: IMenuItem;
  className?: string;
}

export default function MenuItem({ item, className }: IMenuItemProps) {
  const bem = bemBlock(blockName);
  const { label, icon } = item as MenuItemBase;
  const { href } = item as MenuItemHref;
  const { onClick } = item as MenuItemClickable;

  function handleClick() {
    if (onClick) {
      onClick();
    } else if (href) {
      navigateTo(href);
    }
  }

  return (
    <PopoverListItem
      className={bem(null, null, className)}
      prepend={<div className={bem('label')}>{label}</div>}
      icon={icon}
      onClick={handleClick}
    />
  );
}
